import {
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
} from "@chakra-ui/react";

import { G1Button } from "@components/G1Button";
import { ConfirmModalProps } from "@components/Modals/ModalConstants";

export const ConfirmModal = (props: ConfirmModalProps) => {
    const { isOpen, onClose, headerText, bodyText, onAccept } = props;
    return (
        <Modal onClose={onClose} size="xs" isOpen={isOpen} closeOnEsc={true} isCentered={true}>
            <ModalOverlay backdropFilter="blur(6px)" />
            <ModalContent>
                <ModalHeader>{headerText}</ModalHeader>
                <ModalCloseButton />
                <ModalBody>{bodyText}</ModalBody>
                <ModalFooter margin="auto">
                    <G1Button component="global" variant="normal" title="Oui" marginRight="2%" width="100px" onClick={onAccept} />
                    <G1Button component="global" variant="cancel" title="non" marginRight="2%" width="100px" onClick={onClose} />
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};
